import moment from "moment";
import { FEED_COUNT, RECENT_WALL_COUNT, POST_THIS_WEEK, SOCIAL, DASHBOARD_WALL_LOADER, RECENT_POST_LOADER, GET_RECENT_POST_DATA, VISITOR_CLICKS_DATA, GET_WALL_SENTIMENT_LIVE_TREND_DASHBOARD_DATA, MOST_ACTIVE_USERS_DASHBOARD, MOST_ACTIVE_USERS_DASHBOARD_LOADER, WALL_SENTIMENT_LIVE_DASHBOARD_LOADER, VISITOR_CLICKS_LOADER, SOCIAL_LOADER } from "../reducers/keys";
import { GET_WALL_SENTIMENT_LIVE_TREND, VERIFICATION_EMAIL_API } from "./api";
import { ACCOUNT_SUMMARY, ACCOUNT_SUMMARY_NEW, API_GET_WALL_RECORD_MOST_ACTIVE_USERS, POST_THIS_WEEK_SUMMARY, REACT_WALL_SUMMARY, RECENT_POST_DATA, SOCIAL_SUMMARY, VISITOR_CLICKS } from "./api";
import HttpClient from "./http-client";
import { checkLoginToken } from './loginActions';
import { getWallIDs } from "../utils";

export const IS = localStorage.getItem('access_token');

export const reSendEmail = (emailID, product) => new HttpClient().post(VERIFICATION_EMAIL_API, { emailId: emailID, activeProduct: product })

export const loadHomeNew = (status = 0, start, end , walls=0) => {

    return (dispatch) => {
        const startDate = moment(start).format("YYYY-MM-DD HH:mm:ss");
        const endDate = moment(end).format("YYYY-MM-DD HH:mm:ss");
        
        if(status !=3){
        dispatch({ type: DASHBOARD_WALL_LOADER, payload: true });
        const isRecent = status === 2;
        const fetchType = status === 3 ? 1 : 0;

        if (status == 1) {
            dispatch({ type: MOST_ACTIVE_USERS_DASHBOARD_LOADER, payload: true });
            dispatch({ type: VISITOR_CLICKS_LOADER, payload: true })
            dispatch({ type: WALL_SENTIMENT_LIVE_DASHBOARD_LOADER, payload: true });
            dispatch({ type: SOCIAL_LOADER, payload: true });
        }

         dispatch({ type: RECENT_POST_LOADER, payload: true })



        new HttpClient().get(ACCOUNT_SUMMARY_NEW).then((response) => {
            const { responseData, responseCode } = response.data;
            if (responseCode == 200) {
                dispatch({ type: FEED_COUNT, payload: responseData, });
                // (status 2 = rename post), (1 = update all data), (3 = wall,leaderboard Data)
                if (responseData?.allWalllist && Object.keys(responseData.allWalllist).length && status) {
                    let WallIDs = getWallIDs(responseData.allWalllist)
                    isRecent ? recentPost(dispatch) : fetchData(dispatch, fetchType, startDate, endDate, WallIDs );
                }
            }
        })
            .catch((error) => {
                dispatch({ type: DASHBOARD_WALL_LOADER, payload: false, });
                checkLoginToken(error);
            });
      }
      else{
        getwallRecordMostActiveUsers(dispatch, startDate, endDate, walls )
      }
        
    };
};


export const loadHome = () => {
    return (dispatch) => {
        new HttpClient().get(`${ACCOUNT_SUMMARY}`).then((response) => {
            const { responseData, responseCode } = response.data;
            if (responseCode == 200) dispatch({ type: FEED_COUNT, payload: responseData, });
        })
            .catch((error) => { checkLoginToken(error); });
    };
};

const fetchData = (dispatch, fetchType, startDate, endDate , WallIDs) => {

    const requestData = (func) => { func(dispatch, startDate, endDate , WallIDs) };

    if (!fetchType) {
        requestData(getsentimentLiveTrend);
        requestData(recentPost);
        requestData(get_social_account);
        requestData(get_visitor_clicks);
        requestData(getwallRecordMostActiveUsers);
    }
};


const recentPost = (dispatch) => {
    new HttpClient().post(`${RECENT_POST_DATA}`).then((response) => {
        const { status, data } = response
        if (status == 200) dispatch({ type: GET_RECENT_POST_DATA, payload: data.responseData })
    }).catch((error) => {
        dispatch({ type: RECENT_POST_LOADER, payload: false })
    });
}


const get_visitor_clicks = (dispatch) => {
    new HttpClient().get(`${VISITOR_CLICKS}`).then((response) => {
        if (response.data.responseCode == 200) dispatch({ type: VISITOR_CLICKS_DATA, payload: response.data.responseData })
    }).catch((error) => {
        dispatch({ type: VISITOR_CLICKS_LOADER, payload: false })
    });
}


const getwallRecordMostActiveUsers = (dispatch, startDate, endDate, walls=0) => {
    const url = `${API_GET_WALL_RECORD_MOST_ACTIVE_USERS}/${walls}/${startDate}/${endDate}/0/0/5`;
    new HttpClient().get(url).then(({ data: { responseData } }) => {
        dispatch({ type: MOST_ACTIVE_USERS_DASHBOARD, payload: responseData });
    })
        .catch((error) => {
            console.error("LAYOUT ISSUE", error);
            dispatch({ type: MOST_ACTIVE_USERS_DASHBOARD_LOADER, payload: false });
        });
};


export const getwallRecordMostActiveUsersMoreDashboad = (wallID=0, startDate, endDate, feedID, offset, limit, postType, username) => {
    const startDateNew = moment(startDate).format('YYYY-MM-DD HH:mm:ss');
    const endDateNew = moment(endDate).format('YYYY-MM-DD HH:mm:ss');
    const url = `${API_GET_WALL_RECORD_MOST_ACTIVE_USERS}/${wallID}/${startDateNew}/${endDateNew}/0/${offset}/${limit}/0${username ? `/${username}` : ""}`;
    return new HttpClient().get(url);
};


export const getsentimentLiveTrendMore = (e) => {
    return (dispatch) => {
        dispatch({ type: WALL_SENTIMENT_LIVE_DASHBOARD_LOADER, payload: true });
        getsentimentLiveTrend(dispatch, '', '', '', e)
    }
}


const getsentimentLiveTrend = (dispatch, startDate, endDate, WallIDs=0, dateValue = 1 ) => {
    const getDate = moment().subtract(dateValue, 'days')
    const startDt = getDate.utc().unix();
    const endDt = moment().utc().unix();

    new HttpClient().get(`${GET_WALL_SENTIMENT_LIVE_TREND}/${WallIDs}/${startDt}/${endDt}/${0}/${0}`).then((response) => {
        const { responseData } = response.data;
        dispatch({ type: GET_WALL_SENTIMENT_LIVE_TREND_DASHBOARD_DATA, payload: responseData, });
    })
        .catch((error) => {
            console.error("LAYOUT ISSUE", error);
            dispatch({ type: WALL_SENTIMENT_LIVE_DASHBOARD_LOADER, payload: false });
        });
};


const get_social_account = (dispatch) => {
    new HttpClient().get(`${SOCIAL_SUMMARY}`).then((response) => {
        if (response.data.responseCode == 200) dispatch({ type: SOCIAL, payload: response.data.responseData })
    }).catch((error) => {
        dispatch({ type: SOCIAL_LOADER, payload: false });
    });
}


export const Recent_wall = () => {
    return (dispatch) => {
        new HttpClient().get(`${REACT_WALL_SUMMARY}`).then((response) => {
            if (response.data.responseCode == 200) dispatch({ type: RECENT_WALL_COUNT, payload: response.data.responseData })
        }).catch((error) => {
            checkLoginToken(error);
        });
    }
}


export const post_week = () => {
    return (dispatch) => {
        new HttpClient().get(`${POST_THIS_WEEK_SUMMARY}`).then((response) => {
            if (response.data.responseCode == 200) dispatch({ type: POST_THIS_WEEK, payload: response.data.responseData })
        }).catch((error) => {
            checkLoginToken(error);
        });
    }
}

export const social_account = () => {
    return (dispatch) => {
        new HttpClient().get(`${SOCIAL_SUMMARY}`).then((response) => {
            if (response.data.responseCode == 200) dispatch({ type: SOCIAL, payload: response.data.responseData })
        }).catch((error) => {
            checkLoginToken(error);
        });
    }
}
